import React, { memo } from "react";
import "./styles.scss";
import { trackClick } from "../Api";

const ListItem = ({
  componentType,
  pagePath,
  title,
  highlightedTitle,
  description,
  category,
  showHide,
  componentPath,
  clickTrackingEnabled,
  index
}) => {

  ListItem.propTypes = {
    componentType: PropTypes.string.isRequired,
    pagePath: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    highlightedTitle: PropTypes.string.isRequired,
    description: PropTypes.string,
    category: PropTypes.string,
    showHide: PropTypes.string.isRequired,
    componentPath: PropTypes.string.isRequired,
    clickTrackingEnabled: PropTypes.bool.isRequired,
    index: PropTypes.number
  };

  const trackTitleClickInDataLayer = (e, title, type) => {
    let componentType = "Site Search";
    if (type === "product-finder") {
      componentType = "Product Finder";
    }
    window.adobeDataLayer?.push({
      event: window.adobeDataLayerEvents?.component.searchClickthrough,
      type: componentType,
      linkDetails: {
        clickName: e.target.textContent,
        clickType: "listitem title",
        clickDestination: pagePath,
        clickLocation: "search result",
        card: {
          name: title,
          index: index + 1
        },
      },
    });
  };

  return (
    <div
      className={`cmp-listitem${showHide}`}
    >
      <section className={`cmp-listitem__content`}>
        {category && <span className="cmp-listitem__category">{category}</span>}
        <a
          href={pagePath}
          className="cmp-listitem__title"
          onClick={(e) => {
            trackTitleClickInDataLayer(e, title, componentType);
            if (clickTrackingEnabled) {
              trackClick(componentPath, pagePath);
            }
          }}
        >
          <span dangerouslySetInnerHTML={{ __html: highlightedTitle }} />
        </a>
        {description && <p className="cmp-listitem__description" dangerouslySetInnerHTML={{ __html: description }} />}
        <a href={pagePath} className="pageLink">{pagePath}</a>
      </section>
    </div>
  );
};

export default memo(ListItem);
